import { P2GBox, P2GCheckBoxLegacy, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { FilterOptionsGridMode } from './FilterOptionsGrid';

interface incExcPops {
  mode: FilterOptionsGridMode;
  setMode: (mode: FilterOptionsGridMode) => void;
  ctr?: ReactNode;
  children: ReactNode;
}

const IncExc: React.FC<incExcPops> = (props) => (
  <P2GBox>
    <P2GBox pt={2} pb={1}>
      {props.children}
    </P2GBox>
    <P2GBox>
      <P2GGrid container spacing={2} alignItems="center">
        {props.ctr && (
          <P2GGrid item flexGrow={1}>
            {props.ctr}
          </P2GGrid>
        )}
        <P2GGrid item flexShrink={1}>
          <P2GCheckBoxLegacy
            labelPlacement="start"
            error={false}
            variant="primary"
            size="small"
            onChange={() => props.setMode(props.mode === 'EXC' ? 'INC' : 'EXC')}
            id="dd"
            checked={props.mode === 'EXC'}
            label={<P2GText variant="body2">Exclude Matches</P2GText>}
          />
        </P2GGrid>
      </P2GGrid>
    </P2GBox>
  </P2GBox>
);

export default IncExc;
